/** @jsxImportSource @emotion/react */
import { CardContainer } from "../../../../components/page-skeleton/CardContainer";
import { PageHeader } from "../../../../components/page-skeleton/PageHeader";
import { useGetPaymentInstruments } from "../../service/adyen-account-holders-api";
import { useParams } from "react-router";
import { Divider } from "../../../../components/Divider";
import { CardBody } from "../../../../components/page-skeleton/CardBody";
import { css } from "@emotion/react";
import { EmptyState } from "../../../../components/EmptyState";
import { SpinnerBlock } from "../../../common/Spinner";
import { AdyenAccountHolderPaymentInstsrumentsTable } from "./AdyenAccountHolderPaymentInstsrumentsTable";
import { PageFooter } from "../../../../components/page-skeleton/PageFooter";
import { StyledText } from "../../../../assets/typography/typography";

const cardBodyAdditionalStyling = css`
  padding-bottom: 24px;
`;

export const PaymentInstruments = () => {
  const { id } = useParams();
  const { data: paymentInstruments, isLoading } = useGetPaymentInstruments(id);

  if (isLoading) {
    return <SpinnerBlock />;
  }

  return (
    <CardContainer>
      <PageHeader
        title="Payment instruments"
        subtitle="See all your payment instruments"
      />
      {!paymentInstruments || paymentInstruments.length === 0 ? (
        <>
          <Divider />
          <CardBody additionalStyles={cardBodyAdditionalStyling}>
            <EmptyState
              title="No payment instruments"
              subtitle="Get in contact with HeapsGo."
            />
          </CardBody>
        </>
      ) : (
        <div>
          <AdyenAccountHolderPaymentInstsrumentsTable
            paymentInstruments={paymentInstruments}
          />
          <PageFooter>
            <StyledText className="bodyTextRegular mb-0">
              {paymentInstruments.length}{" "}
              {paymentInstruments.length === 1
                ? "payment instrument"
                : "payment instruments"}{" "}
              in total
            </StyledText>
          </PageFooter>
        </div>
      )}
    </CardContainer>
  );
};
